import React from 'react'
import { NextImage } from '@/components/NextImage'
import { useImage } from '@/hooks/images/useImage'

import classNames from 'classnames'
import classes from './styles.module.scss'

interface TeamCardProps {
  item: any
  isPlaceholder?: boolean
  handleCardClick?: (item: any) => void
}

export const TeamCard: React.FC<TeamCardProps> = (props) => {
  const {
    item: rawItem,
    isPlaceholder = false,
    handleCardClick = (item: any) => null,
  } = props
  const item = rawItem?.innerObject || {}

  const { url: image } = useImage({
    id: item?.flag,
    cut: 'square',
    scale: '75',
  })

  return (
    <div
      onClick={() => handleCardClick(item)}
      className={classNames({
        [classes.card]: true,
        [classes['card--placeholder']]: isPlaceholder,
      })}
    >
      <div className={classes.image}>
        <NextImage
          alt={item?.name || 'team-flag'}
          fill={true}
          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 20vw"
          src={image}
        />
      </div>
      <div className={classes.name}>
        <h3>{item?.name}</h3>
      </div>
    </div>
  )
}